"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Pill.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaults = {
  dtextClasses: 'interff m0 ml12 mlr12 lh1'
};

var Pill = function Pill(props) {
  var dtextClasses = defaults.dtextClasses;
  var active = props.active,
      children = props.children,
      customColorScheme = props.customColorScheme,
      deleteFunc = props["delete"],
      defaultClasses = props.defaultClasses,
      handleClick = props.handleClick,
      padding = props.padding,
      textClasses = props.textClasses;
  var realTextClasses = textClasses ? "".concat(textClasses, " ").concat(textClasses) : "".concat(dtextClasses, " fz15");
  var realDefaultClasses = active ? 'posr pill active-pill bd1-s-green curp' : 'posr pill bd1-s-lightgray curp tac';
  var customStyles = {};
  if (defaultClasses) realDefaultClasses = "".concat(realDefaultClasses, " ").concat(defaultClasses);

  if (customColorScheme) {
    Object.keys(customColorScheme).filter(function (k) {
      return k === "backgroundColor" || k === "border";
    }).forEach(function (rule) {
      return customStyles[rule] = customColorScheme[rule];
    });
  } else realDefaultClasses += " default-pill-color-scheme";

  if (padding) customStyles['padding'] = padding;else customStyles['padding'] = '10px';
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown() {
      return null;
    },
    className: realDefaultClasses,
    style: customStyles,
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dib"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: realTextClasses,
    style: {
      top: '-2px',
      position: 'relative'
    }
  }, children)), deleteFunc ? /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: 0,
    "aria-label": "Delete",
    onKeyDown: function onKeyDown() {
      return null;
    },
    className: "deleteIcon dib flr c-black pl5 pr5 fz10 curp",
    onClick: deleteFunc
  }) : null);
};

Pill.defaultProps = {
  active: false,
  "delete": null,
  defaultClasses: '',
  handleClick: null,
  textClasses: null
};
Pill.propTypes = {
  active: _propTypes["default"].bool,
  // children: PropTypes.element.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].element]),
  "delete": _propTypes["default"].func,
  defaultClasses: _propTypes["default"].string,
  handleClick: _propTypes["default"].func,
  textClasses: _propTypes["default"].string
};
var _default = Pill;
exports["default"] = _default;